export default __webpack_public_path__ + "static/media/gg-investigative-cropped.542e9fef.png";